import SearchOutlined from '@mui/icons-material/SearchOutlined';
import Box from '@mui/material/Box';
import type { ChangeEvent, KeyboardEvent, ReactNode } from 'react';

interface MenuSearchInputProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
}

export function MenuSearchInput({
  placeholder,
  value,
  onChange,
  autoFocus = false,
}: MenuSearchInputProps): ReactNode {
  return (
    <Box
      sx={(theme) => ({
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        py: 1,
        px: 1,
        border: '1px solid',
        borderColor: theme.palette.border.strong,
        borderRadius: 1,
        bgcolor: theme.palette.background.paper,
        '&:focus-within': { borderColor: theme.palette.primary.main },
      })}
    >
      <SearchOutlined sx={{ fontSize: 16, color: 'text.disabled', flexShrink: 0 }} />
      <Box
        component="input"
        autoFocus={autoFocus}
        type="text"
        placeholder={placeholder}
        value={value}
        aria-label={placeholder}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        // Keeps typed letters from the menu's type-ahead; Escape still reaches the menu to close it.
        onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
          if (event.key !== 'Escape') event.stopPropagation();
        }}
        sx={(theme) => ({
          flex: 1,
          minWidth: 0,
          border: 'none',
          outline: 'none',
          color: theme.palette.text.primary,
          bgcolor: 'transparent',
        })}
      />
    </Box>
  );
}
